module.exports = __webpack_public_path__ + "img/cob.bd0b2237.svg";